import { useState } from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import { Grid } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import useForm from "../common/AsyncFormBox/useForm";
import { getInitialValue } from "./internal/dateInputUtils";

DateRangeInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.node,
  labelFrom: PropTypes.node,
  labelTo: PropTypes.node,
  defaultValue: PropTypes.array,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  maxDate: PropTypes.instanceOf(dayjs),
  errorText: PropTypes.string,
};

function DateRangeInput({
  name,
  label,
  labelFrom,
  labelTo,
  defaultValue,
  onChange,
  required,
  maxDate,
  errorText,
  readOnly,
  size,
}) {
  const form = useForm();
  const [valueFrom, setValueFrom] = useState(getInitialValue(defaultValue?.[0], name + "_from", form));
  const [valueTo, setValueTo] = useState(getInitialValue(defaultValue?.[1], name + "_to", form));

  function handleSetValueFrom(newValue) {
    if (!newValue || !newValue.isValid()) return;

    const onChangeValue = [newValue, valueTo];
    setValueFrom(newValue);
    if (valueTo && newValue > valueTo) {
      setValueTo(null);
      onChangeValue[1] = null;
    }

    form?.setValue(name, onChangeValue);
    onChange && onChange(onChangeValue);
  }

  function handleSetValueTo(newValue) {
    if (!newValue || !newValue.isValid()) return;

    setValueTo(newValue);
    const onChangeValue = [valueFrom, newValue];
    form?.setValue(name, onChangeValue);
    onChange && onChange(onChangeValue);
  }

  return (
    <Grid container spacing={1}>
      <Grid size={{ xs: 6 }}>
        <DatePicker
          format={"DD.MM.YYYY"}
          slotProps={{
            textField: {
              fullWidth: true,
              required: required,
              name: name + "_from",
              error: !!errorText,
              helperText: errorText,
              InputProps: { readOnly },
              variant: readOnly ? "filled" : "standard",
              size: size,
            },
          }}
          label={labelFrom || label}
          value={valueFrom}
          onChange={handleSetValueFrom}
          maxDate={maxDate}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <DatePicker
          format={"DD.MM.YYYY"}
          slotProps={{
            textField: {
              fullWidth: true,
              required: required || !!valueFrom,
              name: name + "_to",
              error: !!errorText,
              helperText: errorText,
              InputProps: { readOnly },
              variant: readOnly ? "filled" : "standard",
              size: size,
            },
          }}
          label={labelTo || label}
          value={valueTo}
          onChange={handleSetValueTo}
          minDate={valueFrom}
          maxDate={maxDate}
        />
      </Grid>
    </Grid>
  );
}

export default DateRangeInput;
